import { render, staticRenderFns } from "./TermDialog.vue?vue&type=template&id=590e48d4&scoped=true"
import script from "./TermDialog.vue?vue&type=script&lang=js"
export * from "./TermDialog.vue?vue&type=script&lang=js"
import style0 from "./TermDialog.vue?vue&type=style&index=0&id=590e48d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590e48d4",
  null
  
)

export default component.exports